import { Component, OnDestroy, OnInit } from '@angular/core';
import { LegalService } from '../../services/legal.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { AuthService } from '@aiwyn/auth';
import { ConfigService, Globals } from '@aiwyn/config';
import { NavigationEnd, Router } from '@angular/router';
import { ROUTE_TOKEN_ENGAGEMENTS_BASE } from '../../routing-constants';
import { ROUTES_WITHOUT_HEADER } from './main.model';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false,
})
export class MainComponent implements OnInit, OnDestroy {

  openPlaidLinkSubscription: Subscription;

  private _unsubscribe$ = new Subject<void>();

  isEngagementsRoute$: Observable<boolean> = this.router.events.pipe(
    filter<NavigationEnd>(event => event instanceof NavigationEnd),
    map(event => event.url.includes(ROUTE_TOKEN_ENGAGEMENTS_BASE)),
    startWith(this.router.url.includes(ROUTE_TOKEN_ENGAGEMENTS_BASE)),
  );

  isHeaderHidden$: Observable<boolean>;

  constructor(
    public authService: AuthService,
    public legalService: LegalService,
    public configService: ConfigService,
    public globals: Globals,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    this.isHeaderHidden$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event as NavigationEnd),
      startWith({ url: this.router.url }),
      map(({ url }) => ROUTES_WITHOUT_HEADER.some(route => route.test(url))),
    );
  }


  /**
   * Destroy Subscriptions.
   */
  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
    if (this.openPlaidLinkSubscription && !this.openPlaidLinkSubscription.closed) {
      this.openPlaidLinkSubscription.unsubscribe();
    }
    if (this.openPlaidLinkSubscription && !this.openPlaidLinkSubscription.closed) {
      this.openPlaidLinkSubscription.unsubscribe();
    }
  }
}
